interface IconDoubleAltArrowRightProps {
  className?: string;
}

export const IconDoubleAltArrowRight = ({
  className = "",
}: IconDoubleAltArrowRightProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      d="M7.33301 12.6666L11.333 7.99992L7.33301 3.33325"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.5"
      d="M4.66699 12.6666L8.66702 7.99992L4.66699 3.33325"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
